import type {
  MaintenanceRequest,
  ManagedProperty,
  RentRecord,
  TenancyApplication,
  Tenant,
} from '../types/operations'

export const managedProperties: ManagedProperty[] = [
  {
    id: 'prp-1',
    name: 'Cedarwood Student Residence',
    address: '14 Iwaya Road, Onike, Lagos',
    kind: 'Student residence',
    verification: 'verified',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5715fab3-71e3-45b5-ab73-f35483eb12e6.jpg',
    buildings: [
      {
        id: 'bld-1',
        name: 'Block A',
        floors: ['Ground', 'First', 'Second'],
        rooms: [
          {
            id: 'rm-a101',
            label: 'A-101',
            floor: 'Ground',
            roomType: 'Single ensuite',
            beds: [{ id: 'bd-1', label: 'Bed 1', status: 'occupied', tenantName: 'Blessing I.', rentPerYear: 740000 }],
          },
          {
            id: 'rm-a102',
            label: 'A-102',
            floor: 'Ground',
            roomType: 'Single ensuite',
            beds: [{ id: 'bd-2', label: 'Bed 1', status: 'vacant', rentPerYear: 740000 }],
          },
          {
            id: 'rm-a201',
            label: 'A-201',
            floor: 'First',
            roomType: 'Twin share',
            beds: [
              { id: 'bd-3', label: 'Bed 1', status: 'occupied', tenantName: 'Uche M.', rentPerYear: 460000 },
              { id: 'bd-4', label: 'Bed 2', status: 'reserved', tenantName: 'Held for application', rentPerYear: 460000 },
            ],
          },
          {
            id: 'rm-a202',
            label: 'A-202',
            floor: 'First',
            roomType: 'Twin share',
            beds: [
              { id: 'bd-5', label: 'Bed 1', status: 'occupied', tenantName: 'Fatima B.', rentPerYear: 460000 },
              { id: 'bd-6', label: 'Bed 2', status: 'maintenance', rentPerYear: 460000 },
            ],
          },
        ],
      },
      {
        id: 'bld-2',
        name: 'Block B',
        floors: ['Ground', 'First'],
        rooms: [
          {
            id: 'rm-b101',
            label: 'B-101',
            floor: 'Ground',
            roomType: 'Single ensuite',
            beds: [{ id: 'bd-7', label: 'Bed 1', status: 'occupied', tenantName: 'Samuel A.', rentPerYear: 740000 }],
          },
          {
            id: 'rm-b204',
            label: 'B-204',
            floor: 'First',
            roomType: 'Single ensuite',
            beds: [{ id: 'bd-8', label: 'Bed 1', status: 'occupied', tenantName: 'Amarachi O.', rentPerYear: 740000 }],
          },
          {
            id: 'rm-b205',
            label: 'B-205',
            floor: 'First',
            roomType: 'Single ensuite',
            beds: [{ id: 'bd-9', label: 'Bed 1', status: 'vacant', rentPerYear: 740000 }],
          },
        ],
      },
    ],
  },
  {
    id: 'prp-2',
    name: 'Onike Self-Contained Studios',
    address: '5 Onike Crescent, Onike, Lagos',
    kind: 'Self-contained',
    verification: 'verified',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/3b704982-012a-4f5e-8f7c-93051700b0ee.jpg',
    buildings: [
      {
        id: 'bld-3',
        name: 'Main compound',
        floors: ['Ground'],
        rooms: [
          {
            id: 'rm-s1',
            label: 'Studio 1',
            floor: 'Ground',
            roomType: 'Studio',
            beds: [{ id: 'bd-10', label: 'Bed 1', status: 'occupied', tenantName: 'Kelechi D.', rentPerYear: 480000 }],
          },
          {
            id: 'rm-s2',
            label: 'Studio 2',
            floor: 'Ground',
            roomType: 'Studio',
            beds: [{ id: 'bd-11', label: 'Bed 1', status: 'vacant', rentPerYear: 480000 }],
          },
          {
            id: 'rm-s3',
            label: 'Studio 3',
            floor: 'Ground',
            roomType: 'Studio',
            beds: [{ id: 'bd-12', label: 'Bed 1', status: 'vacant', rentPerYear: 480000 }],
          },
        ],
      },
    ],
  },
  {
    id: 'prp-3',
    name: 'Iwaya Gated Annex',
    address: '18 Iwaya Road, Iwaya, Lagos',
    kind: 'Apartment',
    verification: 'pending',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7435e9e0-7693-467a-bd06-ea65f08e4a66.jpg',
    buildings: [
      {
        id: 'bld-4',
        name: 'Annex',
        floors: ['Ground'],
        rooms: [
          {
            id: 'rm-f1',
            label: 'Flat 1',
            floor: 'Ground',
            roomType: 'One bedroom',
            beds: [{ id: 'bd-13', label: 'Bed 1', status: 'vacant', rentPerYear: 650000 }],
          },
          {
            id: 'rm-f2',
            label: 'Flat 2',
            floor: 'Ground',
            roomType: 'One bedroom',
            beds: [{ id: 'bd-14', label: 'Bed 1', status: 'vacant', rentPerYear: 650000 }],
          },
        ],
      },
    ],
  },
]

export const tenancyApplications: TenancyApplication[] = [
  {
    id: 'tap-1',
    applicant: 'Amarachi Obi',
    programme: 'B.Sc. Systems Engineering, 300L',
    property: 'Cedarwood Student Residence',
    roomPreference: 'Single ensuite',
    moveIn: '1 Sep 2026',
    submitted: '9 Aug 2026',
    status: 'Screening',
    compatibilityNote: 'Budget and move-in date match available inventory.',
  },
  {
    id: 'tap-2',
    applicant: 'Tolu Adeleke',
    programme: 'B.Eng. Civil Engineering, 400L',
    property: 'Cedarwood Student Residence',
    roomPreference: 'Twin share',
    moveIn: '1 Sep 2026',
    submitted: '10 Aug 2026',
    status: 'New',
  },
  {
    id: 'tap-3',
    applicant: 'Ifeoma Eze',
    programme: 'B.Sc. Systems Engineering, 300L',
    property: 'Onike Self-Contained Studios',
    roomPreference: 'Studio',
    moveIn: '1 Sep 2026',
    submitted: '8 Aug 2026',
    status: 'Approved',
  },
  {
    id: 'tap-4',
    applicant: 'Segun Fashola',
    programme: 'B.Sc. Economics, 300L',
    property: 'Iwaya Gated Annex',
    roomPreference: 'One bedroom',
    moveIn: '1 Nov 2026',
    submitted: '3 Aug 2026',
    status: 'Declined',
  },
  {
    id: 'tap-5',
    applicant: 'Daniel Uzo',
    programme: 'B.Sc. Computer Science, 300L',
    property: 'Cedarwood Student Residence',
    roomPreference: 'Single ensuite',
    moveIn: '15 Sep 2026',
    submitted: '11 Aug 2026',
    status: 'New',
  },
]

export const tenants: Tenant[] = [
  {
    id: 'tnt-1',
    name: 'Amarachi Obi',
    property: 'Cedarwood',
    unit: 'B-204',
    leaseStart: '1 Sep 2025',
    leaseEnd: '31 Aug 2026',
    rentPerYear: 740000,
    balance: 185000,
    status: 'Ending soon',
  },
  {
    id: 'tnt-2',
    name: 'Blessing Ibrahim',
    property: 'Cedarwood',
    unit: 'A-101',
    leaseStart: '1 Sep 2025',
    leaseEnd: '31 Aug 2026',
    rentPerYear: 740000,
    balance: 0,
    status: 'Current',
  },
  {
    id: 'tnt-3',
    name: 'Uche Mbadiwe',
    property: 'Cedarwood',
    unit: 'A-201 Bed 1',
    leaseStart: '1 Oct 2025',
    leaseEnd: '30 Sep 2026',
    rentPerYear: 460000,
    balance: 0,
    status: 'Current',
  },
  {
    id: 'tnt-4',
    name: 'Fatima Bello',
    property: 'Cedarwood',
    unit: 'A-202 Bed 1',
    leaseStart: '1 Sep 2025',
    leaseEnd: '31 Aug 2026',
    rentPerYear: 460000,
    balance: 230000,
    status: 'Overdue',
  },
  {
    id: 'tnt-5',
    name: 'Samuel Ajayi',
    property: 'Cedarwood',
    unit: 'B-101',
    leaseStart: '1 Jan 2026',
    leaseEnd: '31 Dec 2026',
    rentPerYear: 740000,
    balance: 0,
    status: 'Current',
  },
  {
    id: 'tnt-6',
    name: 'Kelechi Duru',
    property: 'Onike Studios',
    unit: 'Studio 1',
    leaseStart: '1 Sep 2025',
    leaseEnd: '31 Aug 2026',
    rentPerYear: 480000,
    balance: 0,
    status: 'Ending soon',
  },
]

export const rentLedger: RentRecord[] = [
  {
    id: 'rnt-1',
    tenant: 'Amarachi Obi',
    unit: 'B-204',
    period: 'Instalment 2 of 2',
    amount: 185000,
    due: '22 Aug 2026',
    status: 'Pending',
    method: 'HavaPay transfer',
  },
  {
    id: 'rnt-2',
    tenant: 'Fatima Bello',
    unit: 'A-202 Bed 1',
    period: 'Instalment 2 of 2',
    amount: 230000,
    due: '31 Jul 2026',
    status: 'Overdue',
    method: 'HavaPay transfer',
  },
  {
    id: 'rnt-3',
    tenant: 'Blessing Ibrahim',
    unit: 'A-101',
    period: 'Annual',
    amount: 740000,
    due: '1 Sep 2025',
    status: 'Paid',
    method: 'HavaPay transfer',
  },
  {
    id: 'rnt-4',
    tenant: 'Samuel Ajayi',
    unit: 'B-101',
    period: 'Annual',
    amount: 740000,
    due: '1 Jan 2026',
    status: 'Paid',
    method: 'Bank transfer',
  },
  {
    id: 'rnt-5',
    tenant: 'Kelechi Duru',
    unit: 'Studio 1',
    period: 'Annual',
    amount: 480000,
    due: '1 Sep 2025',
    status: 'Paid',
    method: 'HavaPay transfer',
  },
  {
    id: 'rnt-6',
    tenant: 'Uche Mbadiwe',
    unit: 'A-201 Bed 1',
    period: 'Annual',
    amount: 460000,
    due: '1 Oct 2025',
    status: 'Paid',
    method: 'HavaPay transfer',
  },
]

export const maintenanceRequests: MaintenanceRequest[] = [
  {
    id: 'mnt-1',
    reference: 'MR-1043',
    property: 'Cedarwood',
    unit: 'A-202 Bed 2',
    category: 'Plumbing',
    raised: '11 Aug 2026',
    priority: 'Urgent',
    status: 'In progress',
    assignee: 'Tunde (plumber)',
  },
  {
    id: 'mnt-2',
    reference: 'MR-1041',
    property: 'Cedarwood',
    unit: 'Block A stairwell',
    category: 'Electrical',
    raised: '9 Aug 2026',
    priority: 'Normal',
    status: 'Scheduled',
    assignee: 'Ede Electrics',
  },
  {
    id: 'mnt-3',
    reference: 'MR-1038',
    property: 'Onike Studios',
    unit: 'Studio 2',
    category: 'Painting',
    raised: '4 Aug 2026',
    priority: 'Low',
    status: 'Open',
    assignee: 'Unassigned',
  },
  {
    id: 'mnt-4',
    reference: 'MR-1030',
    property: 'Cedarwood',
    unit: 'B-101',
    category: 'Internet',
    raised: '28 Jul 2026',
    priority: 'Normal',
    status: 'Closed',
    assignee: 'Fibre One',
  },
]

export const occupancyTrend = [
  { month: 'Mar', occupancy: 78 },
  { month: 'Apr', occupancy: 81 },
  { month: 'May', occupancy: 84 },
  { month: 'Jun', occupancy: 72 },
  { month: 'Jul', occupancy: 69 },
  { month: 'Aug', occupancy: 74 },
]
